export const GTM_ID = 'GTM-M2FPQZCX'

declare global {
    interface Window {
        dataLayer?: Record<string, unknown>[]
    }
}

export const isGtmEnabled = () => import.meta.env.VITE_ENVIRONMENT === 'production'

let initialized = false

export const pushDataLayer = (event: Record<string, unknown>) => {
    if (!initialized || typeof window === 'undefined') return
    window.dataLayer?.push(event)
}

export const initGtm = () => {
    if (initialized || typeof window === 'undefined' || !isGtmEnabled()) return
    initialized = true

    window.dataLayer = window.dataLayer ?? []
    pushDataLayer({ 'gtm.start': Date.now(), event: 'gtm.js' })

    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`
    document.head.appendChild(script)
}
